/* eslint-disable */

import request from '@/utils/request'

export function getListCurrencyApi(query) {
  return request({
    url: '/config-service/v1/currency/all',
    method: 'get',
    params: query
  })
}

export function addCurrencyApi(query) {
  return request({
    url: '/config-service/v1/currency/add',
    method: 'post',
    data: query
  })
}

export function updateCurrencyApi(query) {
  return request({
    url: '/config-service/v1/currency/update',
    method: 'put',
    data: query
  })
}

export function deleteCurrencyApi(query) {
  return request({
    url: '/config-service/v1/currency/delete-ids',
    method: 'delete',
    data: query
  })
}

export function getMaterialCurrencyListApi(query) {
  return request({
    url: '/config-service/v1/currency/to-excel',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}
